module.exports = __webpack_public_path__ + "img/49DAO.cb400271.png";